import { Tour } from "../TourProvider.types";

export const TourOrganizationManage: Tour = {
  name: "How to manage your organization",
  pages: ["organizationProjects"],
  conditions: { isOrgAdmin: true, isPersonalSpace: false },
  description:
    "Learn about managing your organization's name, projects, and members.",
  steps: [
    {
      anchorId: "organization-edit-menu",
      title: "Change your organization’s name",
      content:
        "Use this gear menu to edit your organization's display name for all members.",
    },
    {
      anchorId: "organization-people",
      title: "Organization Membership",
      content: "Click here to view and manage the users in your organization.",
    },
    {
      anchorId: "organization-usage",
      title: "Organization Usage and Projects",
      content:
        "Click here to view and manage your organization's usage, including overall total storage and compute credits used as well as broken down by project.",
    },
  ],
};
